import { z } from 'zod'
import { SickLeaveScope } from '../types/partner'
import { normalisePolicyHolder } from './sickLeaveRouting'

// The uniqueness check refines the union, not one of its options: zod reads `option.shape[mode]`
// when building a discriminated union, and a refined option is a ZodEffects with no `shape`.
export const sickLeaveSchema = z.discriminatedUnion('mode', [
    z.object({
        mode: z.literal(SickLeaveScope.all),
        email_to: z.string().min(1),
        email_cc: z.string().optional(),
    }),
    z.object({
        mode: z.literal(SickLeaveScope.perPolicyHolder),
        policy_holders: z.array(z.object({
            policy_holder: z.string().min(1),
            email_to: z.string().min(1),
            email_cc: z.string().optional(),
        })),
    }),
]).refine(
    (v) => v.mode !== SickLeaveScope.perPolicyHolder
        || new Set(v.policy_holders.map(p => normalisePolicyHolder(p.policy_holder))).size === v.policy_holders.length,
    { path: ['policy_holders'], message: 'Each policy holder may appear only once' },
)
